<template>
  <div class="app event-container">
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside/> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'event-container',
    components: {
    },
    fields: {
    },
    data () {
      return {
      };
    },
    computed: {
    },
    props: [],
    mounted () {
    }
  };
</script>



// WEBPACK FOOTER //
// Event.vue?a49e9a98